import { AnyAction } from '@reduxjs/toolkit'

import { FETCH_USER_SUCCESS } from '@/store/actionTypes'

import {
  ADD_USER_SUCCESS,
  PASSWORD_RESET_SUCCESS,
  UPDATE_SEARCH_EMAIL_SUCCESS,
  UPDATE_SEARCH_EXTERNAL_ID_SUCCESS
} from './actionTypes'

type OrganizationUserEditPageState = {
  isEmailAvailable: object
  isExternalIdAvailable: object
  isValidatingEmail: boolean
  user?: string
  otp?: object
}

const initialState: OrganizationUserEditPageState = {
  isEmailAvailable: {},
  isExternalIdAvailable: {},
  isValidatingEmail: false
}

export default function organizationEditUsersPageReducer(
  state = initialState,
  action: AnyAction
): OrganizationUserEditPageState {
  switch (action.type) {
    case FETCH_USER_SUCCESS: {
      return { ...state, user: action.response.id }
    }
    case UPDATE_SEARCH_EMAIL_SUCCESS: {
      return {
        ...state,
        isEmailAvailable: { ...state.isEmailAvailable, [action.value]: action.response.totalResults === 0 }
      }
    }
    case UPDATE_SEARCH_EXTERNAL_ID_SUCCESS: {
      return {
        ...state,
        isExternalIdAvailable: { ...state.isExternalIdAvailable, [action.value]: action.response.totalResults === 0 }
      }
    }
    case ADD_USER_SUCCESS: {
      return {
        ...state,
        user: action.response.id,
        otp: {}
      }
    }
    case PASSWORD_RESET_SUCCESS: {
      return { ...state, otp: action.response }
    }
    default: {
      return state
    }
  }
}
